import React from "react";
import { useMediaQuery } from "react-responsive";
import { useComponentsStore } from "../../Stores/componentsStore";

export function useColorScheme() {
  const colourSchemeKey = `${import.meta.env.VITE_COLOR_SCHEME_KEY}_${import.meta.env.VITE_VERSION}`;
  const [isDark, setIsDark] = React.useState(localStorage.getItem(colourSchemeKey) || "light");
  const [setDark] = useComponentsStore((state) => [state.setIsDark]);
  React.useEffect(() => {
    localStorage.setItem(colourSchemeKey, isDark);
    setDark(isDark === "light" ? false : true);
  }, [isDark, setDark, colourSchemeKey]);

  const systemPrefersDark = useMediaQuery(
    {
      query: "(prefers-color-scheme: dark)",
    },
    undefined
  );
  const value = React.useMemo(() => (isDark === undefined ? !!systemPrefersDark : isDark), [isDark, systemPrefersDark]);
  React.useEffect(() => {
    if (value === "dark") {
      document.body.classList.add("dark");
    } else {
      document.body.classList.remove("dark");
    }
    return () => {};
  }, [value]);

  return {
    isDark: value,
    setIsDark: setIsDark,
  };
}
